import React from 'react';
import { BrowserRouter as Router, Route} from 'react-router-dom';

import ProductOverview from './components/checkout/tariff-details/ProductOverview';
import OrderForm from './components/checkout/customer-data/OrderForm';
import PayPal from './components/checkout/paypal/PayPal';
import CheckoutSummary from './components/checkout/summary/CheckoutSummary';
import Download from './components/download/Download';
import Footer from './components/shared/footer/Footer';
import Header from './components/shared/header/Header';
import ProductDetails from './components/product-details/ProductDetails';
import CheckoutFailure from './components/shared/outcomes/CheckoutFailure';
import SecondDownload from './components/shared/outcomes/SecondDownload';
import NotFound from './components/shared/outcomes/NotFound';
import InvalidSession from './components/shared/outcomes/InvalidSession';
import CheckoutSuccess from './components/shared/outcomes/CheckoutSuccess';
import CancelOrderDownload from './components/download/CancelOrderDownload';
import DuplicateDownload from './components/download/DuplicateDownload';
import WithdrawalDownload from './components/download/WithdrawalDownload';
import ServerError from './components/shared/outcomes/ServerError';

import axios from 'axios';

class Routing extends React.Component {
  constructor(props) {
    super(props);

    axios.defaults.headers.common['Content-Type'] = 'application/json';

    if(sessionStorage.getItem('x-csrf-token') !== undefined && sessionStorage.getItem('x-csrf-token') !== null) {
      axios.defaults.headers.common['x-csrf-token'] = sessionStorage.getItem('x-csrf-token');
    }

    if(localStorage.getItem('x-csrf-token') !== undefined && localStorage.getItem('x-csrf-token') !== null) {
      axios.defaults.headers.common['x-csrf-token'] = localStorage.getItem('x-csrf-token');
    }

    axios.interceptors.response.use(function (response) {
      if(response.status === 204) {
        axios.defaults.headers.common['x-csrf-token'] = response.headers['x-csrf-token'];

        sessionStorage.setItem('x-csrf-token', response.headers['x-csrf-token']);
        localStorage.setItem('x-csrf-token', response.headers['x-csrf-token']);

        return axios.request(response.config);
      } else {
        return response;
      }
    }, function (error) {
      return Promise.reject(error);
    });
  }

  render() {
    return(
      <div className= "container_wrapper">
        <Header />
        <main className="main-esc_container">
          <Router>
            <Route exact path="/" component={ProductDetails} />
            <Route path="/internet-schutzbrief/tarifdaten/:ANR?" component={ProductOverview} />
            <Route path="/internet-schutzbrief/persoenliches/:ANR?" component={OrderForm} />
            <Route path="/internet-schutzbrief/bezahlmethode" component={PayPal} />
            <Route path="/internet-schutzbrief/uebersicht" component={CheckoutSummary} />
            <Route path="/internet-schutzbrief/:hash/police" component={Download} />
            <Route path="/internet-schutzbrief/:hash/storno" component={CancelOrderDownload} />
            <Route path="/internet-schutzbrief/:hash/zweitschrift" component={DuplicateDownload} />
            <Route path="/internet-schutzbrief/:hash/ruecktritt" component={WithdrawalDownload} />
            <Route exact path="/internet-schutzbrief" component={ProductDetails} />
            <Route exact path="/internet-schutzbrief/technischer-fehler" component={CheckoutFailure} />
            <Route exact path="/internet-schutzbrief/bereits-runtergeladen" component={SecondDownload} />
            <Route exact path="/internet-schutzbrief/info" component={CheckoutSuccess} />
            <Route exact path="/internet-schutzbrief/404" component={NotFound} />
            <Route exact path="/internet-schutzbrief/403" component={InvalidSession} />
            <Route exact path="/internet-schutzbrief/anfrage-fehlgeschlagen" component={ServerError} />
          </Router>
        </main>
        <Footer />
      </div>
    )
  }
}

export default Routing;
